import { render, staticRenderFns } from "./BindsDrawerRightPrevious.vue?vue&type=template&id=c7a64dfa&"
import script from "./BindsDrawerRightPrevious.vue?vue&type=script&lang=js&"
export * from "./BindsDrawerRightPrevious.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports